import {CommonModule} from '@angular/common';
import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CmsConfig, I18nModule, UrlModule, provideDefaultConfig} from '@spartacus/core';
import {GenericLinkModule} from '@spartacus/storefront';
import {DcpConfiguratorLeavePageConfirmationModalComponent} from './dcp-configurator-leave-page-confirmation-modal/dcp-configurator-leave-page-confirmation-modal.component';
import {DcpConfiguratorProductTitleComponent} from './dcp-configurator-product-title.component';

@NgModule({
  imports: [CommonModule, I18nModule, UrlModule, GenericLinkModule],
  providers: [
    provideDefaultConfig({
      cmsComponents: {
        ConfiguratorProductTitle: {
          component: DcpConfiguratorProductTitleComponent,
        },
      },
    } as CmsConfig),
  ],
  declarations: [DcpConfiguratorProductTitleComponent, DcpConfiguratorLeavePageConfirmationModalComponent],
  exports: [DcpConfiguratorProductTitleComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class DcpConfiguratorProductTitleModule {}
